import { useFeatureIsOn, useFeatureValue } from "@growthbook/growthbook-react";

import FeaturedNewsHero from "../../components/news/FeaturedNewsHero";
import TopStoriesRow from "../../components/news/TopStoriesRow";
import LatestNewsGrid from "../../components/news/LatestNewsGrid";
import EventSpotlight from "../../components/news/EventSpotlight";
import SectionTitle from "../../components/common/SectionTitle";
import StandingsSection from "../../components/standings/StandingsSection";
import { mockEvents } from "../../data/mockEvents";
import { mockArticles } from "../../data/mockNews";
import {growthbook} from "../../lib/growthbook";

export default function HomePage() {
    const showStandings = useFeatureIsOn("show-standings-home");
    const showFeaturedEvent = useFeatureIsOn("show-featured-event");
    const showNewsSection = useFeatureIsOn("show-news-home");
    const ctaLabel = useFeatureValue(
        "event-program-cta-copy",
        "Voir le programme"
    );

    const topStories = mockArticles.slice(0, 3);
    const latestArticles = mockArticles.slice(0, 6);
    const featuredEvent =
        mockEvents.find((event) => event.featured) ?? mockEvents[0];

    console.log("HomePage ctaLabel raw =", ctaLabel);
    console.log("HomePage ctaLabel json =", JSON.stringify(ctaLabel));
    console.log("HomePage is sunday =", ctaLabel === "Voir les matchs du dimanche");
    console.log("HomePage is string true =", ctaLabel === "true");
    console.log(
        "HomePage direct feature value =",
        JSON.stringify(
            growthbook.getFeatureValue("event-program-cta-copy", "fallback")
        )
    );

    console.log("HomePage showStandings =", showStandings);
    console.log("HomePage showFeaturedEvent =", showFeaturedEvent);
    console.log("HomePage showNewsSection =", showNewsSection);
    console.log("HomePage CTA label =", ctaLabel);

    console.log("HomePage ctaLabel =", ctaLabel, "type =", typeof ctaLabel);
    return (
        <div className="space-y-12 py-6 md:space-y-16">
            <section>
                <SectionTitle title="Bienvenue" />
            </section>

            {showStandings && <StandingsSection />}

            {showFeaturedEvent && featuredEvent && (
                <section>
                    <SectionTitle title="Événement vedette" />
                    <EventSpotlight event={featuredEvent} />
                </section>
            )}
        </div>
    );
}